import { render, staticRenderFns } from "./terms.vue?vue&type=template&id=30f2659c&scoped=true&"
import script from "./terms.vue?vue&type=script&lang=js&"
export * from "./terms.vue?vue&type=script&lang=js&"
import style0 from "./terms.vue?vue&type=style&index=0&lang=css&"
import style1 from "./terms.vue?vue&type=style&index=1&id=30f2659c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f2659c",
  null
  
)

export default component.exports